export const SIGNUP = '/signup'
export const LOGIN = '/login'
export const BASICPROFILE = '/basic-details'
export const VERIFICATION = '/contact'
export const SIGNUP1 = '/'
export const DASHBOARD = '/dashboard'
export const MYPROFILE = '/my-profile'
export const ASSESSMENTS = '/assessments'
export const JOBS = '/jobs'
export const JOBDETAILS = '/jobdetails'
export const APPLIEDJOBS = '/applied-jobs'
export const HELP = '/help'
export const SETTINGS = '/settings'
export const FORGOTPASSWORD = '/forgotpassword'
export const RESETPASSWORD = '/resetpassword'
export const ERRORPAGE = '/error'
export const SUBMITVERIFICATION = '/submitVerification'
export const NONVERIFIEDDASHBOARD = '/verification'
export const RESUMESHARE = '/resumeshare'
export const MYRATING = '/myrating'
export const SURVEY = '/survey'
export const TIMESHEET = '/timesheet'
export const ADDTIMESHEET = '/addTimesheet'
export const SUBMITTIMESHEET = '/submittimesheet'
export const MYCONTRACTS = '/mycontracts'
export const INVOICEGENERATOR = '/invoicegenerator'
export const CONTRACTSIGNIN = '/contractsignin'
export const HEALTHINSURANCE = '/healthinsurance'
export const REFERANDEARN = '/referandearn'
export const REFERANDEARNDETAILS = '/referandearn-details'
export const REFERANDEARNPROFILE = '/referandearn-profile'
export const FALLBACKPAGE = '*'
